import React, { useContext, useEffect, useState } from 'react';
import { I18nContext } from 'translations';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { modalMessageHtml } from 'utils';
import Loading from 'components/Loading';
import { useStateValue } from 'context/store';
// import { listStoresShopify } from 'context/sales/actions';
import {
  configurationWoocommerce,
  listStoresWoocommerce,
} from 'context/integrations/actions';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import FormConfigurationWooCommerce from './FormConfigurationWooCommerce';

const WooCommerceStoreConfigurationModal = ({ open, setOpen, store }) => {
  const { translate } = useContext(I18nContext);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [
    {
      sales: { listWooCommerceStores },
    },
    dispatch,
  ] = useStateValue();
  

  const getStores = useCallback(async () => {
    return await listStoresWoocommerce(dispatch);
  }, [dispatch]);

  useEffect(() => {
    getStores();
  }, []); // eslint-disable-line

  const messageOk = () => {
    setLoading(false);
    modalMessageHtml(
      translate('congratulations'),
      translate('app.integration.settingStore.form.successful'),
      'success',
      translate('app.integration.settingStore.goToSales'),
      true,
      translate('app.integration.settingStore.continueSetting'),
      false
    ).then((response) => {
      response.isConfirmed ? history.push('/app/bookings/sales') : getStores();
    });
  };

  const submit = async (values) => {
    setLoading(true);
    const callback = await configurationWoocommerce(
      dispatch,
      store.user_external_identificator,
      { ...values, store_name: store.user_external_identificator }
    );
    callback?.status ? messageOk() : setLoading(false);
  };

  return (
    <>
      <Dialog
        open={open}
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
        >
        <DialogTitle className="text-center" disableTypography>
          <Typography variant="h5" color="primary">
            {translate('app.woocommerce.settingWooCommerce.title')}
          </Typography>
        </DialogTitle>
        <DialogContent style={{ margin: '10px 0' }}>
        {loading && <Loading />}
          <FormConfigurationWooCommerce
            listWooCommerceStores={listWooCommerceStores || []}
            submit={submit}
            storeName={store.user_external_identificator}
          />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={setOpen}>
            {translate('close')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WooCommerceStoreConfigurationModal;
